// extracted by mini-css-extract-plugin
export default {"user-info":"user-info--1z_ho","skeleton":"skeleton--1huNT","username":"username--27Eb_","calls":"calls--2iuY7","rotate-icon":"rotate-icon--1GS4i"};